import { EntityId } from "@jackfruit/common"
import { useEffect } from "react"
import { useApplicationState } from "~/hooks/useApplicationState"
import { useMetaDescription } from "~/hooks/useMetaDescription"
import { useMetaTitle } from "~/hooks/useMetaTitle"
import { useOpenGraphImage } from "~/hooks/useOpenGraphImage"
import { useProduct } from "~/hooks/useProduct"
import { useProductImages } from "~/hooks/useProductImages"

export const useSetPageMetaForProduct = (
  productId: EntityId,
  pageId: EntityId
) => {
  const { displayName } = useApplicationState()
  const [_metaTitle, setMetaTitle] = useMetaTitle(pageId)
  const [_metaDescription, setMetaDescription] = useMetaDescription(pageId)
  const [_openGraphImage, setOpenGraphImage] = useOpenGraphImage(pageId)
  const { product } = useProduct(productId)
  const { productImages } = useProductImages(productId)

  const desktopImage = productImages.find(
    image => image?.metaData?.web?.desktop?.merchant
  )

  useEffect(() => {
    if (product) {
      const { shortDescription, longDescription } = product

      setMetaTitle(`${shortDescription} | ${displayName}`)
      setMetaDescription(longDescription)

      if (desktopImage) {
        setOpenGraphImage({
          url: desktopImage.url,
          width: 500,
          height: 500,
        })
      }
    }
  }, [
    desktopImage,
    displayName,
    product,
    setMetaDescription,
    setMetaTitle,
    setOpenGraphImage,
  ])
}
